class Animations {

  constructor() {

    this.debug = window.location.search == "?debug" ? true : false;

    if(this.debug) console.log('Animations constructor');

  }

  init() {

    let _self = this;

    var url = new URL(window.location.href);
    this.debug = !!url.searchParams.get("debug") || this.debug;
    if(_self.debug) console.log('Animations debug enabled', _self.debug);

    if(_self.debug) console.log('$ ?', $, 'lottie?', lottie);

    var lottieAnimations = lottie.getRegisteredAnimations();
    var lottieScrollTriggers = [];
    // animate/pause lottie when scrolled in view/out of view
    if(lottieAnimations.length) {
      $.each(lottieAnimations, function(i,lottieAnimation){

        if(_self.debug) console.log('lottieAnimation', lottieAnimation);
          var lottieScrollTrigger = ScrollTrigger.create({
            id: lottieAnimation.name || 'lottieAnimation-'+i,
            trigger: lottieAnimation.wrapper,
            start: "top bottom",
            end: "bottom top",
            onToggle: self => {
              if(_self.debug) console.log("toggled, lottieAnimation"+i+" isActive:", self.isActive);
              if(window.innerWidth < 1280 || (lottieAnimation.autoplay && lottieAnimation.loop)) {
                //is it in view ?
                if (self.isActive) {
                  lottieAnimation.play();
                } else {
                  lottieAnimation.pause();
                }

              }

            },
            markers: false,
          });

          lottieScrollTriggers.push(lottieScrollTrigger);
        if(lottieAnimation.autoplay && lottieAnimation.loop) {
        } else {
          if(_self.debug) console.log('lottieAnimation MOUSEENTER', $(lottieAnimation.wrapper))
          $(lottieAnimation.wrapper).on('mouseenter', { animation: lottieAnimation, _this: _self }, _self.playAnimationOnMousenter);
          if($(lottieAnimation.wrapper).closest('.card').length) $(lottieAnimation.wrapper).closest('.card').on('mouseenter', { animation: lottieAnimation, _this: _self }, _self.playAnimationOnMousenter);


        }

        if(lottieAnimation.autoplay == false && lottieAnimation.loop == false) {
          lottieAnimation.onComplete = function(e) {
            if(_self.debug) console.log('animation complete?', e, this);
            this.goToAndStop(0);
            if(_self.debug) console.log('animation complete', e);
            //e.data.animation.name);
            // $(e.data.animation.wrapper).one('mouseenter', { animation: e.data.animation }, _self.playAnimationOnMousenter);
          };
        }

      });

      // freeze/unfreeze lottie when window is visible/hidden
      document.addEventListener('visibilitychange', function (event) {
        if (document.hidden) {
          if(_self.debug) console.log('not visible');
          lottie.freeze();
        } else {
          if(_self.debug) console.log('is visible');
          lottie.unfreeze();
        }
      });

    }
  }

  playAnimationOnMousenter(e){

    let _self = this;

    if(e.data._this.debug) console.log('playAnimationOnMousenter e', e, 'e.data.animation', e.data.animation);
    if(e.data.animation.isPaused) {
      //rewind
      e.data.animation.goToAndStop(0);
      e.data.animation.setDirection(1);
      e.data.animation.play();
      if(e.data.autoplay == false && e.data.loop == false) {
        e.data.animation.onComplete = function(e) {
          if(_self.debug) console.log('animation complete?', e, this);
          this.goToAndStop(0);
          if(_self.debug) console.log('animation complete', e);
          //e.data.animation.name);
          // $(e.data.animation.wrapper).one('mouseenter', { animation: e.data.animation }, _self.playAnimationOnMousenter);
        };
      }
      // e.data.animation.addEventListener('complete', function(e) {
      //   console.log('animation complete?', e, this);
      //   if(_self.debug) console.log('animation complete', e);
      //   //e.data.animation.name);
      //   // $(e.data.animation.wrapper).one('mouseenter', { animation: e.data.animation }, _self.playAnimationOnMousenter);
      // }, {once: true});
    }
  }

}

export { Animations };
